import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';

import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { ConnectsComponent } from './components/connects/connects.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: 'admin', component: ConnectsComponent },
      {
        path: 'church-list',
        loadComponent: () =>
          import('./components/church-list/church-list.component').then(
            (x) => x.ChurchListComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./components/settings/settings.component').then(
            (x) => x.SettingsComponent
          ),
      },
      { path: '', redirectTo: 'admin', pathMatch: 'full' },
      { path: '**', component: PageNotFoundComponent, pathMatch: 'full' },
    ],
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: 'admin', pathMatch: 'full' },
];
